import { match } from "ts-pattern";
import { CloseRounded } from "@mui/icons-material";
import { Box, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { colors, fonts } from "../../theme";
import { CountryCode, useGetAttributeProductsQuery } from "../../generated/storefront";

type Props = {
  dialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  selectedCountry: CountryCode;
};

const MountDialog = ({ dialogOpen, setDialogOpen, selectedCountry }: Props) => {
  const { data: attributeProductsData } = useGetAttributeProductsQuery({
    variables: { country: selectedCountry },
  });
  const { mountingProduct } = attributeProductsData || {};
  const mountLabel = match(selectedCountry)
    .with(CountryCode.Us, () => "Matt")
    .otherwise(() => "Mount");
  const mountingLabel = match(selectedCountry)
    .with(CountryCode.Us, () => "Matting")
    .otherwise(() => "Mounting");

  return (
    <Dialog onClose={() => setDialogOpen(false)} open={dialogOpen}>
      <CloseRounded
        onClick={() => setDialogOpen(false)}
        sx={{
          cursor: "pointer",
          position: "absolute",
          top: 0,
          right: 0,
          background: colors.white,
          borderRadius: "100%",
          margin: 1,
          padding: 1,
          width: 32,
          height: 32,
          zIndex: 10,
        }}
      />

      <DialogContent>
        <Stack gap={2}>
          <Box
            height={{ xs: "calc(100vw - 32px)", md: 500 }}
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={mountingProduct?.images.nodes[0].src}
              alt="mounting"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
          <Stack gap={1}>
            <Typography variant="h4">{mountingLabel}</Typography>
            <Typography fontSize={{ xs: 12, md: 14 }} fontFamily={fonts.body}>
              Enhance your framed piece with a 2 inch {mountLabel.toLowerCase()} around your print. The card is a
              conservation-grade, 2.4mm thick {mountLabel.toLowerCase()} board with bevelled edges. Note that the{" "}
              {mountLabel.toLowerCase()} will reduce the size of the print by 2 inches on each side.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default MountDialog;
